import { render, staticRenderFns } from "./ValidateErrorModal.vue?vue&type=template&id=b015f20e&scoped=true"
import script from "./ValidateErrorModal.vue?vue&type=script&lang=js"
export * from "./ValidateErrorModal.vue?vue&type=script&lang=js"
import style0 from "./ValidateErrorModal.vue?vue&type=style&index=0&id=b015f20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b015f20e",
  null
  
)

export default component.exports